import React from "react";

/**
 * Guidance shown under every field that is automatically translated.
 *
 * Anything wrapped in double square brackets is left exactly as typed in all languages;
 * everything around it is translated. Without this, place names get translated too -
 * "Ourense" became "Orense" in Spanish and "Sarria" became "サリア" in Japanese.
 */
export const TranslationHint = () => (
  <span style={{ fontSize: 12, color: "#8c8c8c" }}>
    Wrap town and place names in double brackets so they are never translated, e.g.{" "}
    <code style={{ background: "#f5f5f5", padding: "1px 4px", borderRadius: 3 }}>
      The route runs from [[Sarria]] to [[Portomarín]]
    </code>
    . The brackets are removed automatically and never appear in the app.
  </span>
);

export default TranslationHint;
